import { useConfirmDialog } from '@abovo/shared-ui-components';
import { UnsavedChangesActions, UnsavedChangesState, getUnsavedChangesState } from '@abovo/webvis-data-access';
import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { Store } from '@ngrx/store';
import { Observable, first, mergeMap } from 'rxjs';

@Injectable({
   providedIn: 'root',
})
export class LeavePageGuard {
   private confirmDialog = useConfirmDialog();

   constructor(private store: Store<UnsavedChangesState>) {}

   canDeactivate(_route: ActivatedRouteSnapshot, _state: RouterStateSnapshot): Observable<boolean> {
      return this.store.select(getUnsavedChangesState).pipe(
         first(),
         mergeMap(async ({ noUnsavedChanges, message }) => {
            if (noUnsavedChanges) {
               return noUnsavedChanges;
            }

            const dialog = this.confirmDialog.open({
               title: message?.title,
               message: message?.message,
               cancelButton: message?.cancelButton,
               removeButton: message?.removeButton,
            });
            const accepted = await dialog.afterClosed;

            if (accepted) {
               this.store.dispatch(UnsavedChangesActions.setUnsavedChanges({ noUnsavedChanges: true }));
            } else {
               this.store.dispatch(UnsavedChangesActions.setNavigate({ canNavigate: false }));
            }

            return accepted;
         }),
      );
   }
}
